module.exports = __webpack_public_path__ + "static/media/magnifying-glass.2a3f3c0f.svg";